module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/court-type/courttype-view/courttype-view.component.css
// module id = ./src/app/master/court-type/courttype-view/courttype-view.component.css
// module chunks = main